var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5a5a5a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10,16.387l5.571,3.529a.547.547,0,0,0,.808-.611L14.9,12.654l4.914-4.468a.575.575,0,0,0-.313-1l-6.476-.577L10.493.348a.527.527,0,0,0-.991,0L6.969,6.614.493,7.191a.573.573,0,0,0-.3,1L5.1,12.654,3.629,19.305a.547.547,0,0,0,.808.611Z",
    transform: "translate(0)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10,0V16.387L4.438,19.916a.543.543,0,0,1-.823-.492l.015-.119,1.477-6.651L.191,8.186A.578.578,0,0,1,.38,7.214l.113-.023,6.478-.577L9.5.348A.529.529,0,0,1,10,0Z",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStarHalf);
export default __webpack_public_path__ + "static/media/icon-star-half.789985728271590991106fb6efd780ba.svg";
export { ForwardRef as ReactComponent };